import LoadingScreen from './component'
export default LoadingScreen
